import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=cc63f582&scoped=true&"
import script from "./CustomSelect.vue?vue&type=script&lang=ts&"
export * from "./CustomSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=cc63f582&lang=sass&scoped=true&"
import style1 from "./CustomSelect.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc63f582",
  null
  
)

export default component.exports